// Núcleo puro extraído de usePageVisibilityReconnect para testabilidade isolada
// (Fase 1 P1). Eram closures useCallback dentro do hook, inalcançáveis. O hook
// delega para estas funções preservando o comportamento; `now` é injetável p/
// determinismo nos testes.
import logger from "../utils/logger";

export const MAX_HEARTBEAT_AGE_MS = 60000;

export function isMarketdataHealthy(marketdata, now = Date.now()) {
  if (marketdata.state !== "online") {
    return false;
  }
  const heartbeatAge = now - marketdata.lastHeartbeat;
  if (heartbeatAge > MAX_HEARTBEAT_AGE_MS) {
    console.log(
      `[PageVisibility] Marketdata heartbeat stale: ${Math.round(heartbeatAge / 1000)}s old`,
    );
    return false;
  }
  return true;
}

export function isOrdersRouterHealthy(ordersRouter, now = Date.now()) {
  if (ordersRouter.idle) {
    return true; // não esperado estar conectado
  }
  if (ordersRouter.state !== "online") {
    return false;
  }
  const heartbeatAge = now - ordersRouter.lastHeartbeat;
  if (heartbeatAge > MAX_HEARTBEAT_AGE_MS) {
    console.log(
      `[PageVisibility] OrdersRouter heartbeat stale: ${Math.round(heartbeatAge / 1000)}s old`,
    );
    return false;
  }
  return true;
}

export async function reconnectMarketdata(marketdata) {
  // #304: não auto-reconecta se evicted pelo servidor — exige login explícito.
  if (marketdata.closedByServer) {
    console.log(
      "[PageVisibility] Marketdata closed by server (evicted by another session); skipping auto-reconnect",
    );
    return false;
  }
  if (!marketdata.broker || !marketdata.auth) {
    console.log(
      "[PageVisibility] Cannot reconnect marketdata - no credentials",
    );
    return false;
  }
  try {
    logger.connection.info("Reconectando após retorno da aba", {
      broker: marketdata.broker,
      server: marketdata.getUrl(),
    });
    await marketdata.startUsingAuth(marketdata.broker, marketdata.auth);
    return true;
  } catch (error) {
    console.error("[PageVisibility] ❌ Marketdata reconnection failed:", error);
    return false;
  }
}
